import React from 'react';
import TimelineItem from '../TimelineItem';
import './estilo.scss';


function Experience() {
    const timeline = {
        item: [{
            role: "Software Engineer",
            company: "everis",
            date: "Apr 2018 - today | São Paulo - Brazil",
            list: [{
                title: "FrontEnd",
                subTitle: [
                    "Frontend developer lead of the project (Liv - Livelo Chatbot)",
                    "Code refactoring",
                    "Layout update according new identity's Livelo",
                    "Frontend implementation of communication with Salesforce (Human chat)",
                    "Share knowledge with others developers",
                    "Estimate tasks with the team"
                ]
            },
            {
                title: "BackEnd",
                subTitle: [
                    "Implemented improvements to the main solution (orchestating system) based in Java",
                    "Implemented nem service in Node"
                ]
            }
            ]
        },
        {
            role: "Governance internship",
            company: "BNP Paribas",
            date: "Jan 2016 - Jan 2018 | São Paulo - Brazil",
            list: [{
                title: "Internship",
                subTitle: [
                    "Excel and VBA",
                    "PowerBI",
                    "Responsible for squad's documentation",
                    "Elaborating SLA numbers to presentation"
                ]
            }
            ]
        },
        {
            role: "Audiovisual/IT assistant",
            company: "Colégio Módulo",
            date: "Jan 2014 - Oct 2015 | São Paulo - Brazil",
            list: [{
                title: "Audiovisual",
                subTitle: [
                    "Event schedule",
                    "Audiovisual organize"
                ]
            },
            {
                title: "IT",
                subTitle: [
                    "Network configuration",
                    "Hardware and software maintenance",
                    "IT support"
                ]
            }]
        },
        {
            role: "Soldier",
            company: "Brazilian army",
            date: "Apr 2013 - Jan 2014 | São Paulo - Brazil",
            list: [{
                title: "Soldier",
                subTitle: [
                    "Discipline and hierarchy"
                ]
            }]
        },
        {
            role: "Internship/IT assistant",
            company: "Colégio Módulo",
            date: "Sep 2010 - Apr 2013 | São Paulo - Brazil",
            list: [{
                title: "IT",
                subTitle: [
                    "Network configuration",
                    "Hardware and software maintenance",
                    "IT support"
                ]
            }]
        },
        {
            role: "Internship",
            company: "PRW Power",
            date: "Jan 2010 - Sep 2010 | São Paulo - Brazil",
            list: [{
                title: "IT",
                subTitle: [
                    "Hardware and software maintenance",
                    "IT support",
                    "Customer service",
                    "Sales"
                ]
            }]
        }
        ]
    }
    return (
        <section className="timeline" id="experience">
            <div className="container">
                <TimelineItem timeline={timeline}></TimelineItem>
            </div>
        </section>
    );
}

export default Experience;